import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ProposalDetail from './ProposalDetail';
import { proposalService, authService } from '../services/api';

export default function Proposals() {
  const [proposals, setProposals] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadProposals();
  }, []);

  const loadProposals = async () => {
    try {
      const response = await proposalService.getProposals();
      setProposals(response.data);
      setError(null);
    } catch (err) {
      setError('Error al cargar las propuestas');
      console.error('Error loading proposals:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleVote = async (id) => {
    if (!authService.isAuthenticated()) {
      // Mostrar mensaje para iniciar sesión
      if (window.confirm('Necesitas iniciar sesión para votar. ¿Quieres ir a la página de login?')) {
        window.location.href = '/login';
      }
      return;
    }

    try {
      await proposalService.voteProposal(id);
      // Recargar las propuestas para obtener el conteo actualizado
      loadProposals();
    } catch (err) {
      console.error('Error voting for proposal:', err);
      if (err.response?.status === 401) {
        alert('Tu sesión ha expirado. Por favor, inicia sesión nuevamente.');
        window.location.href = '/login';
      } else {
        alert('Error al votar por la propuesta. Por favor, intenta de nuevo.');
      }
    }
  };

  if (loading) return <div className="text-center py-12">Cargando propuestas...</div>;
  if (error) return <div className="text-center py-12 text-red-600">{error}</div>;

  if (selected) {
    return <ProposalDetail proposal={selected} onBack={() => setSelected(null)} onVote={handleVote} />;
  }

  return (
    <section className="max-w-6xl mx-auto px-4 py-12">
      <h2 className="text-2xl font-bold mb-6">Propuestas</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {proposals.map((p) => (
          <article
            key={p.id}
            className="border rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow duration-300"
          >
            <div className="text-4xl">{p.icon}</div>
            {p.img && <div className="h-60">
              <img 
                src={p.img}
                alt={p.title}
                className="w-full h-full object-cover rounded-xl shadow-md"
              />
            </div>}
            <h3 className="font-semibold mt-2 text-lg">{p.title}</h3>
            <p className="mt-2 text-gray-600 text-sm line-clamp-3">{p.summary}</p>
            <div className="mt-4 flex justify-between items-center">
              <button
                onClick={() => setSelected(p)}
                className="bg-[#69c24d] text-white text-sm px-4 py-2 rounded hover:bg-[#69c24d] transition-colors"
              >
                Ver detalles
              </button>
              {/* <span className="text-sm text-gray-600">
                {p.votes} votos
              </span> */}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
